import { Alert } from 'antd';
import React from "react";
import { useLoaderData } from 'react-router-dom';
import DocumentsDownloader from '../../template/documentDownloader';
import styles from './templateSent.module.scss';
const TemplateSent = () => {
    const { productionDetails, sample } = useLoaderData()
    return (<div className={styles.container}>
        <h3>Template Received</h3>
        <Alert message='Below are the template Sent to Leoprinting' />
        {sample != null && <div>
            {sample && sample.map(({ url, name, comment }) => (
                <DocumentsDownloader image={url} comment={comment} name={name} key={url} project_id={productionDetails.project_id} itemId={productionDetails.id} />
            ))}
        </div>
        }
        <br />
    </div>)
}
export default TemplateSent;
